/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DtmDocsImportDocCreateRequest = {} | null | undefined;
export type DtmDocsImportDocCreateResponse = any;

export type DtmDocsImportDocCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/dtm_docs/{id}/import_doc/
 *
 * ```yaml
 * operationId: dtm_docs_import_doc_create
 * tags:
 *   - dtm_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dtmDocsImportDocCreateOperation = ({ id, ...rest }: DtmDocsImportDocCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/dtm_docs/${id}/import_doc/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dtm_docs/{id}/import_doc/' };
  };

/**
 * POST /dmx-server/dtm_docs/{id}/import_doc/
 *
 * ```yaml
 * operationId: dtm_docs_import_doc_create
 * tags:
 *   - dtm_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dtmDocsImportDocCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DtmDocsImportDocCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dtmDocsImportDocCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
